import type { Story } from '@/store/story-types'

export const PRODUCT_LAUNCH_STORY: Story = {
  id: 'product-launch-1',
  name: 'Product Launch',
  narrative: 'A product launch landing page with frosted glass design, hero product showcase, feature highlights, social proof, and a glowing CTA to drive early sign-ups and conversions.',
  goals: ['Showcase product', 'Highlight key features', 'Build social proof', 'Drive early sign-ups'],
  lifecycle: 'building',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'launch-home', description: 'Single-page launch site with navbar, hero, features, social proof, and CTA',
      blockRef: { category: 'launch', blockId: 'hero-product' } },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'View Hero',
      description: 'Visitor sees the product hero section',
      steps: [
        { type: 'given', text: 'the visitor opens the launch page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the product hero with headline, description, and CTA is visible', linkedPageId: 'launch-home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Explore Features',
      description: 'Visitor browses the product feature highlights',
      steps: [
        { type: 'given', text: 'the visitor is on the launch page' },
        { type: 'when', text: 'they scroll to the features section' },
        { type: 'then', text: 'feature cards with glass effect and descriptions are displayed', linkedPageId: 'launch-home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'View Social Proof',
      description: 'Visitor sees testimonials and social proof',
      steps: [
        { type: 'given', text: 'the visitor is on the launch page' },
        { type: 'when', text: 'they scroll to the social proof section' },
        { type: 'then', text: 'testimonials, logos, or user counts are displayed', linkedPageId: 'launch-home' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Sign Up Early',
      description: 'Visitor signs up via the glowing CTA',
      steps: [
        { type: 'given', text: 'the visitor is convinced by the product' },
        { type: 'when', text: 'they click the glowing CTA button' },
        { type: 'then', text: 'a sign-up form or waitlist entry is presented', linkedFlowId: 'signUpLaunch' },
      ],
    },
  ],
}
